import axios from 'axios';

const TRANSLATIONS_REQUEST_TIMEOUT_MS = 15000;

export class TranslationsService {
  private apiUrl: string;
  private translations!: any;

  constructor() {
    this.apiUrl = import.meta.env.VITE_APP_onBackstageAPI + 'translations/';
  }

  public async getAll(): Promise<any> {
    try {
      if (!this.translations) {
        const response = await axios.get(this.apiUrl, { timeout: TRANSLATIONS_REQUEST_TIMEOUT_MS });
        this.translations = response.data;
      }

      return this.translations;
    } catch (exception) {
      console.info('request failed to fetch translations ', exception);

      return {};
    }
  }

  public async getByLanguage(language: string): Promise<any> {
    try {
      const response = await axios.get(this.apiUrl + language, { timeout: TRANSLATIONS_REQUEST_TIMEOUT_MS });

      return response.data;
    } catch (exception) {
      console.info('request failed to fetch translations ', exception);

      return null;
    }
  }
}
